module.exports = __webpack_public_path__ + "img/companies.60ed2b6c.png";